<template>
	<v-toolbar class="mb-4">
		<v-toolbar-title>
			<slot />
		</v-toolbar-title>
		<v-spacer />
		<v-toolbar-items class="pa-2">
			<slot name="actions" />
		</v-toolbar-items>
	</v-toolbar>
</template>

<script>
	export default {
		name: "title-view",
	};
</script>

<style scoped>

</style>
